module.exports = __webpack_public_path__ + "static/media/SE.d46dbac2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SE.svg
// module id = 2256
// module chunks = 7